import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'

// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(Router)

//  //监听返回处理
//  let returnUrl = ''//返回页面的路径
//  window.addEventListener("popstate", () => {
//    //当前页面触发，location则是要返回的目标页面
//    returnUrl = location.hash
//  }, false);

const router = new Router({
  mode: 'hash',
  // mode: 'history',
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    // console.log(to, from, savedPosition)
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    //   return { x: 0, y: 0 }
    // }
    // console.log(to,from,'777')
    return to.meta.position
  },
})
router.beforeEach((to, from, next) => {
  document.documentElement.scrollTop = 0
  next()
})
export default router
